import { CONTACT_QUALITY_SCORE_SEGMENT } from 'EmailEditorUI/redux/actions/actionTypes';
export const getContactQualityScoreSegmentSelected = percentile => {
  return percentile !== null && percentile !== CONTACT_QUALITY_SCORE_SEGMENT.TOP_100_PERCENTILE_SEGMENT;
};